/* eslint react-hooks/exhaustive-deps: "error" */
import React from 'react';

import { PrimaryButton, Loader, colors } from '@crehana/ui';

import { useCrehanaLiveTranslations } from 'Jsx/CrehanaLive/hooks';

import { MainMenuWrapperProps } from 'Jsx/CrehanaWeb/MainMenuWrapper';

import Separator from 'Jsx/CrehanaLive/components/Separator';
import Hero from 'Jsx/CrehanaLive/sections/Hero';
import NextLives from 'Jsx/CrehanaLive/sections/NextLives';
import CategoriesAndLiveList from 'Jsx/CrehanaLive/sections/CategoriesAndLiveList';
import useCurrentAndNextLives from 'Jsx/CrehanaLive/hooks/useCurrentAndNextLives';

import { LiveCategories } from '../../types';

interface LandingProps {
  liveCategories: LiveCategories;
  setMainMenuProps: (
    props: Partial<MainMenuWrapperProps['layoutConfig']>,
  ) => void;
  enrollToLive: (liveId: number) => Promise<void>;
}

const Landing: React.FC<LandingProps> = ({
  liveCategories,
  setMainMenuProps,
  enrollToLive,
}) => {
  const { t } = useCrehanaLiveTranslations();

  React.useEffect(() => {
    setMainMenuProps({
      hideSearch: true,
      hideInboxLink: true,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { featuredLive, nextLives, showRefetch, loading, refetch } =
    useCurrentAndNextLives();

  if (loading) {
    return (
      <div className="pt-64" style={{ minHeight: 448 }}>
        <Separator className="bg-gr" />
        <div className="pt-32 pb-56 flex justify-center">
          <Loader isWhite />
        </div>
      </div>
    );
  }

  if (showRefetch) {
    return (
      <div style={{ minHeight: 448 }} className="pt-72 px-12 text-center">
        <Separator className="bg-gr" />
        <div className="mt-32 flex flex-col items-center">
          <p className="font-subtitle3 text-white">{t('ERROR_LOAD_LANDING')}</p>
          <PrimaryButton
            label={t('RETRY_AGAIN_LABEL')}
            className="block mt-16"
            onClick={() => refetch()}
            style={{ maxWidth: 300 }}
            darkMode
          />
        </div>
      </div>
    );
  }

  return (
    <React.Fragment>
      <Separator className="hidden md:block w-full bg-base-lighter" />
      <Hero live={featuredLive} />
      <div
        className="relative"
        css={`
          &:before {
            content: '';
            position: absolute;
            z-index: 0;
            top: 0;
            left: 0;
            right: 0;
            height: 2300px;
            background: linear-gradient(
              180deg,
              ${colors.baseDark} 10.62%,
              #523bb6 22.85%,
              #6f4ef6 29.09%,
              #4d39ad 34.28%,
              ${colors.baseDark} 51.44%
            );
          }
        `}
      >
        <div className="pt-56 relative z-1">
          <NextLives lives={nextLives} enrollToLive={enrollToLive} />
        </div>
        <div id="categorias" className="pt-56 relative z-1">
          <CategoriesAndLiveList liveCategories={liveCategories} />
        </div>
      </div>
    </React.Fragment>
  );
};

export default Landing;
